export const customMealCode = {
  NO_MEAL: 'NO_MEAL',
  REGULAR_MEAL: 'REGULAR_MEAL'
};

export const mealTypesToDisplay = {
  [customMealCode.NO_MEAL]: 'notApplicable',
  [customMealCode.REGULAR_MEAL]: 'regularMeal',
  CHML: 'childMeal',
  DBML: 'diabeticMeal',
  DFML: 'dairyFreeMeal',
  GFML: 'glutenFreeMeal',
  KSML: 'kosherMeal',
  LFML: 'lowFatMeal',
  LSML: 'lowSaltMeal',
  MOML: 'halalMeal',
  VGML: 'veganMeal',
  VLML: 'vegetarianMeal'
};

export const regularMeal = { name: mealTypesToDisplay[customMealCode.REGULAR_MEAL], code: customMealCode.REGULAR_MEAL };
export const noMeal = { name: mealTypesToDisplay[customMealCode.NO_MEAL], code: customMealCode.NO_MEAL };
